import { useRef, useState, useEffect } from 'preact/hooks'

import Icon from '@/components/snippets/icon/icon'

import { SearchInput } from 'libs/searchspring/components/quick-search/SearchInput'
import { QuickSearchDropdown } from 'libs/searchspring/components/quick-search/QuickSearchDropdown'
import { SearchspringAutocompleteProvider } from 'libs/searchspring/fetchers/autocomplete'

function QuickSearch({ id = 'quick-search' }) {
  const searchInputRef = useRef()
  const [inputValue, setInputValue] = useState()
  const [query, setQuery] = useState()
  const closeButtonRef = useRef()
  const modalRef = useRef()
  const [redirect, setRedirect] = useState(false)

  const handleFocusInput = () => {
    setTimeout(() => {
      searchInputRef.current.focus()
    }, 0)
  }

  const handleClose = (event) => {
    event.preventDefault()
    modalRef.current?.handleHide()
  }

  const handleUpdateValue = (event) => {
    setInputValue(event.target.value)
  }

  const resetInputValue = () => {
    setInputValue('')
    searchInputRef.current.value = ''
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setQuery(inputValue)
    }, 400)
    return () => {
      clearTimeout(timeout)
    }
  }, [inputValue])

  return (
    <x-modal className="group/search flex items-center h-full z-0" data-id={id} data-body-lock ref={modalRef}>
      <button
        className="flex size-[17px] link-fade children:size-full"
        data-modal-parent={id}
        data-modal-role="open"
        onClick={handleFocusInput}
        aria-label="Toggle search"
      >
        <Icon id="magnifying-glass" />
      </button>
      <div
        className="flex flex-col fixed inset-tl w-full h-fit z-100 -translate-y-full group-data-visible/search:translate-y-0 transition-all"
      >
        <form action="/search" method="get" className="w-full px-margin py-0.5 border-b border-neutral-medium bg-secondary">
          <div className="flex items-center justify-between gap-x-1.5">
            <SearchInput className="grow" ref={searchInputRef} redirect={redirect} onInput={handleUpdateValue} />
            <div className={'flex items-center justify-end gap-x-1.5'}>
              {inputValue ? (
                <button className="text-b text-tertiary font-line link-fade" onClick={resetInputValue} type="reset" aria-label="Clear search">
                  Clear
                </button>
              ) : null}
              <button
                className="flex size-[11px] link-fade children:size-full"
                data-modal-parent={id}
                data-modal-role="close"
                ref={closeButtonRef}
                onClick={handleClose}
                aria-label="Close modal"
              >
                <Icon id="close" />
              </button>
            </div>
          </div>
        </form>
        <SearchspringAutocompleteProvider runOnMount={false} resultsPerPage={4}>
          <QuickSearchDropdown query={query} redirect={redirect} setRedirect={setRedirect} />
        </SearchspringAutocompleteProvider>
      </div>
      <button
        className="fixed inset-tl size-full bg-neutral-black/60 opacity-0 group-data-visible/search:opacity-100 pointer-events-none group-data-visible/search:pointer-events-auto cursor-n-resize z-90 transition-all"
        data-modal-parent={id}
        data-modal-role="close"
        aria-label="Close modal"
      ></button>
    </x-modal>
  )
}

export function WrappedQuickSearch({ id }) {
  return (
    <SearchspringAutocompleteProvider runOnMount={false}>
      <QuickSearch id={id} />
    </SearchspringAutocompleteProvider>
  )
}
